var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("btn",null,{"loadMore":_vm.loadMore,"hasMore":_vm.hasMore})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }